import Raven from 'raven-js';
import { Component } from 'react';
import { moveToPage } from 'unsubscribe-ui/utils/common';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    moveToPage('/backup');
    Raven.captureException(error, {
      extra: {
        message: 'Failed to load component',
        errorInfo
      }
    });
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
export default ErrorBoundary;